import { districtUpdateApi } from "../../api/district/districtUpdateApi"

type PayloadShape = Parameters<typeof districtUpdateApi>[0]

export async function districtUpdateService(payload: PayloadShape, token: string) {
	return await districtUpdateApi(payload, token)
}
